export const ENGAGEMENT_FORM_OPTIONS: { value: string; label: string }[] = [
    { value: 'Kontinuierlich', label: 'Kontinuierlich' },
    { value: 'Projektbezogen', label: 'Projektbezogen' },
    { value: 'Einmaliger Einsatz', label: 'Einmaliger Einsatz' },
];

const HOURS = Array.from({ length: 40 }, (_, i) => i + 1);
export const WORK_LOAD_HOURS_OPTIONS = HOURS.map((h) => ({ value: h, label: `${h}` }));
